import { render, staticRenderFns } from "./PopupEsgCount.vue?vue&type=template&id=54b7871d&scoped=true"
import script from "./PopupEsgCount.vue?vue&type=script&lang=js"
export * from "./PopupEsgCount.vue?vue&type=script&lang=js"
import style0 from "./PopupEsgCount.vue?vue&type=style&index=0&id=54b7871d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7871d",
  null
  
)

export default component.exports